import { clsx } from 'clsx';
import { FC } from 'react';

interface Props {
  className?: string;
}

export const RecaptchaNotice: FC<Props> = ({ className }) => (
  <div className={clsx('c-fs-caption text-tex-def-tie3', className)}>
    This site is protected by reCAPTCHA and the Google{' '}
    <a href="https://policies.google.com/privacy" target="_blank">
      Privacy Policy
    </a>{' '}
    and{' '}
    <a href="https://policies.google.com/terms" target="_blank">
      Terms of Service
    </a>{' '}
    apply.
  </div>
);
